export { default } from './NoticeInfo';

